import axios, {
  AxiosRequestHeaders,
  AxiosError,
  AxiosRequestConfig,
} from "axios";
import { tokenService } from "./tokenService";

interface RetryAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

/* ============================
   INTERCEPTOR DE REQUEST
============================ */
api.interceptors.request.use(
  (config) => {
    const token = tokenService.getToken();

    if (token?.access) {
      if (!config.headers) {
        config.headers = {} as AxiosRequestHeaders;
      }

      config.headers.Authorization = `Bearer ${token.access}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ============================
   INTERCEPTOR DE RESPONSE
============================ */
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as RetryAxiosRequestConfig;

    /* ---------- TENTA REFRESH ---------- */
    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const token = tokenService.getToken();

      if (token?.refresh) {
        try {
          const { data } = await api.post(
            `/auth/token/refresh/`,
            { refresh: token.refresh }
          );

          if (data?.access) {
            const newToken = {
              ...token,
              access: data.access,
            };

            tokenService.setToken(newToken);

            api.defaults.headers.common.Authorization = `Bearer ${data.access}`;

            originalRequest.headers = {
              ...(originalRequest.headers ?? {}),
              Authorization: `Bearer ${data.access}`,
            };

            return api(originalRequest);
          }
        } catch (refreshError) {
          console.error("Falha ao renovar token:", refreshError);
        }
      }
    }

    /* ---------- LOGOUT FORÇADO ---------- */
    if (error.response?.status === 401) {
      tokenService.removeToken();
      delete api.defaults.headers.common.Authorization;

      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
